import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { CardData } from '../.';
import CardRight from './card-right';

const Card: React.FC<{ data: CardData; printMode?: boolean, children: ReactNode }> = ({
	data,
	printMode = false,
	children
}) => {

	return (
		<div
			className={classNames(
				'flex justify-center rounded-2xl max-w-xl mx-auto w-full grid grid-cols-2 font-novartis text-novartis-font h-[226px] md:h-[290px] print:h-[290px]',
				{
					'shadow-leap': !printMode,
					'mx-auto border border-font divide-x-2 divide-font divide-solid py-5':
						printMode,
				}
			)}>
			{children}
			<CardRight data={data} printMode={printMode} />
		</div>
	);
};

export default Card;
